import type { TranslationKey } from '@/i18n';

export const languageSettingsStrings = {
  goBack: 'common.goBack',
  title: 'language.title',
  subtitle: 'language.subtitle',
  systemDefault: 'language.systemDefault',
  systemDefaultDescription: 'language.systemDefaultDescription',
  moreComing: 'language.moreComing',
} as const satisfies Record<string, TranslationKey>;

/**
 * Translation context:
 * Owned by `src/app/settings/language.tsx`, the app language picker.
 * `title` is the screen heading; `subtitle`, `systemDefaultDescription`, and
 * `moreComing` are helper text; `systemDefault` is a selectable option.
 * `goBack` is the shared accessibility label for the header's back button.
 * Keep `opncue` lowercase and unchanged. "System default" means following the
 * device language, with English used when that language is unavailable. The
 * copy about conversations is privacy-sensitive: opncue does not translate a
 * user's conversations.
 */
